import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading || user === undefined) {
    return <div>Carregando...</div>;
  }

  if (user === false) {
    return <Navigate to="/" replace />;
  }

  return children;
}
